import {takeLatest, put, all, call} from 'redux-saga/effects';
import {successToast} from '../actions';
import * as AC from '../actions/actionTypes';
import {
  addAdminApi,
  deleteAdminApi,
  editAdminApi,
  getAdminDetailsApi,
  getAdminsApi,
} from '../api/admins.service';
import history from '../routes/history';
import {errorHandler} from '../utils/errorHandler';

function* getAdminsSaga(fn) {
  try {
    const response = yield call(getAdminsApi, fn.filters);
    yield put({type: AC.GET_ADMINS_SUCCEED, payload: response.data});
  } catch (e) {
    yield errorHandler(e, AC.GET_ADMINS_FAILED);
  }
}

function* getAdminDetailsSaga(fn) {
  try {
    const response = yield call(getAdminDetailsApi, fn.id || fn.payload.id);
    yield put({type: AC.GET_ADMIN_DETAILS_SUCCEED, payload: response.data});
  } catch (e) {
    yield errorHandler(e, AC.GET_ADMIN_DETAILS_FAILED);
  }
}

function* addAdminSaga(fn) {
  try {
    const response = yield call(addAdminApi, fn.payload);
    yield put({type: AC.ADD_ADMIN_SUCCEED, payload: response.data});
    yield put(successToast('Admin created successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.ADD_ADMIN_FAILED);
  }
}

function* editAdminSaga(fn) {
  try {
    const response = yield call(editAdminApi, fn.payload);
    yield put({type: AC.EDIT_ADMIN_SUCCEED, payload: response.data});
    yield put(successToast('Admin edited successfully!'));
  } catch (e) {
    yield errorHandler(e, AC.EDIT_ADMIN_FAILED);
  }
}

function* deleteAdminSaga(fn) {
  try {
    const response = yield call(deleteAdminApi, fn.id);
    yield put({type: AC.DELETE_ADMIN_SUCCEED, payload: response.data});
    yield put(successToast('Admin deleted successfully!'));
    history.back();
  } catch (e) {
    yield errorHandler(e, AC.DELETE_ADMIN_FAILED);
  }
}

function* actionWatcher() {
  yield takeLatest(
    [AC.GET_ADMINS_REQUEST, AC.ADD_ADMIN_SUCCEED],
    getAdminsSaga,
  );
  yield takeLatest(
    [AC.GET_ADMIN_DETAILS_REQUEST, AC.EDIT_ADMIN_SUCCEED],
    getAdminDetailsSaga,
  );
  yield takeLatest(AC.ADD_ADMIN_REQUEST, addAdminSaga);
  yield takeLatest(AC.EDIT_ADMIN_REQUEST, editAdminSaga);
  yield takeLatest(AC.DELETE_ADMIN_REQUEST, deleteAdminSaga);
}

export default function* adminsSaga() {
  yield all([actionWatcher()]);
}
